// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Zi8g","label":"Radio_label__UGuVZ","checkMark":"Radio_checkMark__1MEvF","disabled":"Radio_disabled__299mm"};